import { ErrorLogComponent } from '@cian/error-log-component';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';
import { UiKitRoot, UiKitToastsContextProvider } from '@cian/ui-kit';
import { ContentContainer } from '../ContentContainer';
import { NotificationsContainer } from '../Notifications';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType={initialDeviceType}>
          <UiKitToastsContextProvider>
            <Provider store={reduxStore}>
              <ContentContainer />
              <NotificationsContainer />
            </Provider>
          </UiKitToastsContextProvider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
